import React, { Component } from 'react';
import { Container, Row, Col, Button, Table,Image, Form, DropdownButton, Dropdown, Modal } from 'react-bootstrap';
import NavbarComponent from '../Navbar/index';
import RenovateTokenAlert from '../../RenovateToken';
import ReactNotification from 'react-notifications-component';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { store } from 'react-notifications-component';
import { Bounce } from 'react-activity';
import JsPdf from "jspdf";

// import { store } from 'react-notifications-component';
import InvoicesRow from './InvoicesRow';

import Connection from '../../Calls';
import Backend from '../../Backend';

import wireLogo from '../../Images/logo-wirebit-pdf.png'
import CopyClip from '../../Images/copy-clip.png';
import GAuth from '../../Images/gauth.png'
import './index.css';

var pricesSocket;

function formatMoney(n,c,d,t){
var n = n,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-$" : "$",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;
   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
 };


class InvoicesIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pair_selected_dropdown: "BTC/USD",
      pair_selected: "BTCUSD",
      coin:'btc',
      wallets:[],
      selectedWallet:'',
      address_pay:{},
      invoices:[],
      group_info:{},
      organization_name:'',
      selected_invoice:{},
      selected_coin:'',
      depositModal:false,
      renderWithdrawal:'request',
      amountW:'',
      passwordW:'',
      descriptionW:'Invoice Payment',
    }
    this.changeInfo = this.changeInfo.bind(this);
  }

  componentWillMount(){
    this.getInvoices();
    this.connectPricesSocket();
  }

  componentWillUnmount(){
    if(pricesSocket){
      pricesSocket.close();
      pricesSocket = null;
    }
  }


  getInvoices() {
    const self = this;
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      var payload = response.payload
      Backend.InvoiceInfo(localStorage.getItem('email'), localStorage.getItem('token'), payload.r01, response => {
        if(response.status.code == 0){
          this.setState({
            address_pay:response.payload.address_pay,
            invoices:response.payload.invoices,
            group_info:response.payload.group_info,
            organization_name:response.payload.group_info.organization_name,
          })
          if(response.payload.invoices[0]){
            this.getSingleInvoice(payload, response.payload.invoices[0].uuid)
          }
        }
      });

    });
  }

  changeInfo(item){
    const self = this;
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      this.getSingleInvoice(response.payload,item.uuid)
    })
  }

  getSingleInvoice(payload,uuid){
    Backend.SingleInvoice(localStorage.getItem('email'), localStorage.getItem('token'), payload.r01,uuid, response => {
      this.setState({
        selected_invoice:response.payload.payment,
        selected_coin:response.payload.payment.coin,
        selected_status:response.payload.status,
        selected_period:response.payload.payment_period,
        selected_uuid:uuid
      })
    })
  }

  connectPricesSocket() {
    const self = this;
    var wsProtocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    var wsHost = window.location.hostname === "localhost" ? "50.116.20.64:8765" : window.location.host + "/ws/prices";
    pricesSocket = new WebSocket(wsProtocol + "//" + wsHost);
    pricesSocket.onopen = function (event) {
      pricesSocket.send('GNTWIREBIT')
    }
    pricesSocket.onmessage = function (event) {
      try {
        var object = JSON.parse(event.data);
        self.setState({
          prices: object,
        })
      } catch (e) {

      }
    }
  }
// 1/this.state.prices[coin.toUpperCase() + 'USD']

  renderListInvoices() {
    const self = this;
    var users = [];
    self.state.invoices.forEach(function (row) {
      users.push(
        <InvoicesRow changeInfo={self.changeInfo} row={row} selected_uuid={self.state.selected_uuid} />
      );
    });
    return users;
  }

  BlockchainLinks(coin, tx) {
    var isInternal= tx.indexOf('-')
    if(isInternal == -1){
      switch (coin) {
        case "btc":
          return 'https://www.blockchain.com/en/btc/tx/' + tx; // + '/';
        case "ltc":
          return 'https://blockchair.com/litecoin/transaction/' + tx + '/';
        case "dash":
          return 'https://explorer.dash.org/insight/tx/' + tx + '/';
        case "eth":
          return 'https://etherscan.io/tx/' + tx;
        case "bch":
          return 'https://explorer.bitcoin.com/bch/tx/' + tx + '/';
        case "xrp":
          return 'https://livenet.xrpl.org/transactions/' + tx;
        case "usdt":
          return 'https://solscan.io/tx/' + tx;
        case "sol":
          return 'https://solscan.io/tx/' + tx;
        default:
          return '';
      }
    }else{
      return process.env.REACT_APP_ME_WEB+'transferview?id=' + tx
    }
  }

  sendContactPDF() {
    const self = this;
    self.setState({
      showLoad: true
    })

    var content = ''
    var response =
    'This is a test to see the format COIN: ' + this.state.selected_coin
    + 'STATUS:' + this.state.selected_status
    + 'TX:' + this.state.selected_invoice.tx

    var doc = new JsPdf("p", "mm", "a4");
    doc.setFontSize(15);
    doc.text(145, 20, 'INVOICE');
    doc.setFontSize(12);

    doc.text(170, 20, this.state.selected_uuid);



    var txtPosition = 70;
    var textIncrease = 10;
    doc.setFontSize(15);
    doc.text(10, txtPosition - 10, 'Billed to:');

    doc.setFontSize(10);
    doc.text(10, txtPosition + (textIncrease * 0), 'LEGAL REPRESENTATIVE:');
    doc.text(10, txtPosition + (textIncrease * 1), 'STREET ADDRESS:');
    doc.text(10, txtPosition + (textIncrease * 2), 'COUNTRY:');
    doc.text(10, txtPosition + (textIncrease * 3), 'CELLPHONE:');


    doc.text(65, txtPosition + (textIncrease * 0), '' +this.state.group_info.legal_representative);
    doc.text(65, txtPosition + (textIncrease * 1), '' +this.state.group_info.street_address);
    doc.text(65, txtPosition + (textIncrease * 2), '' +this.state.group_info.country);
    doc.text(65, txtPosition + (textIncrease * 3), '' +this.state.group_info.cellphone);

    doc.setFontSize(15);
    doc.text(110, txtPosition - 10, 'Payment:');

    doc.setFontSize(10);
    doc.text(110, txtPosition + (textIncrease * 0), 'PLAN:');
    doc.text(110, txtPosition + (textIncrease * 1), 'AMOUNT:');
    doc.text(110, txtPosition + (textIncrease * 2), 'TX:');
    doc.text(110, txtPosition + (textIncrease * 3), 'DATE:');

    doc.text(130, txtPosition + (textIncrease * 0), '' + this.state.selected_invoice.plan + ' ' + this.state.selected_period);
    doc.text(130, txtPosition + (textIncrease * 1), '' + this.state.selected_invoice.rcvd_amount + ' ' + this.state.selected_coin.toUpperCase())
    var txSplit = doc.splitTextToSize(this.state.selected_invoice.tx, 70);
    doc.text(130, txtPosition + (textIncrease * 2), '' + txSplit[0]);
    doc.text(130, txtPosition + (textIncrease * 3), '' + this.state.selected_invoice.created_date);

    doc.addImage(wireLogo, 'PNG', 10, 10);
    doc.save("invoice_" + this.state.selected_uuid + ".pdf");
  }

  // addTextParagraph(doc,response, start,){
  //   var height = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
  //   var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
  //   var ParaWidth = pageWidth * 0.85; /* para width will 85% of the page width. */
  //   var LeftMargin = (pageWidth - ParaWidth) / 2;/* Left margin will be half of the remaining space*/
  //   var TopMargin = start;/*According to your requirement*/
  //   var lines = doc.splitTextToSize(response, ParaWidth);
  //
  //   for (var i = 0; i < lines.length; i++) {
  //     if (TopMargin > 280) {
  //       TopMargin = 10;
  //       doc.addPage();
  //     }
  //     doc.text(LeftMargin, TopMargin, lines[i]);
  //     TopMargin = TopMargin + 7;
  //   }
  // }

  render() {
    return (
        <div className="invoice-history-container">
            <Row style={{margin:0}}>
              <Col md={5} className='invoice-table-col'>
                <div className="container-shadow-card-wallets-information">

                  <div className="scroll-table-invoices-generals invoice-half-div">
                    <div className='border-title-separator-container'>
                      <p className='invoices-card-titles'>{this.props.traductions.invoice.titleHistory}</p>
                    </div>
                    <table className="table-container-wallets-generals">
                      <thead>
                        <tr>
                          <th className="header-table-wallets-generals fixxxed">{this.props.traductions.invoice.T_H_priod}</th>
                          <th className="header-table-wallets-generals fixxxed">ID</th>
                          <th className="header-table-wallets-generals fixxxed">{this.props.traductions.invoice.T_H_status}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.renderListInvoices()}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
              <Col md={7} className='invoice-infromation-col'>
                <div className="container-shadow-card-wallets-information">
                  <p className='single-invoice-titles'>{this.props.traductions.invoice.Invoice}: {this.state.selected_uuid} <span className={this.state.selected_status} style={{float:'right'}}>{this.state.selected_status}</span></p>
                  <p className='single-invoice-subtitle'> {this.state.selected_period}</p>
                  <div className='invoice-divider'/>
                  {
                    (this.state.selected_status == 'processed')
                    ?
                    <>
                      <p className='invoices-titles'>{this.props.traductions.invoice.L_billed}:</p>
                      <p className='payment-addresses'>{this.props.traductions.invoice.L_legalRep}: <span style={{float:'right'}}>{this.state.group_info.legal_representative}</span></p>
                      <p className='payment-addresses'>{this.props.traductions.invoice.L_street}: <span style={{float:'right'}}>{this.state.group_info.street_address}</span></p>
                      <p className='payment-addresses'>{this.props.traductions.invoice.L_country}: <span style={{float:'right'}}>{this.state.group_info.country}</span></p>
                      <p className='payment-addresses'>{this.props.traductions.invoice.L_CELLPHONE}: <span style={{float:'right'}}>{this.state.group_info.cellphone}</span></p>
                      <p className='invoices-titles'>{this.props.traductions.invoice.L_info}:</p>
                      <p className='payment-addresses'>{this.props.traductions.invoice.L_coin}: <span style={{float:'right'}}>{this.state.selected_coin.toUpperCase()}</span></p>
                      <p className={'payment-addresses'}>{this.props.traductions.invoice.L_status}: <span className={this.state.selected_status} style={{float:'right'}}>{this.state.selected_status}</span></p>
                      <p className='payment-addresses'>TX: <a target={"_blank"} href={this.BlockchainLinks(this.state.selected_coin, this.state.selected_invoice.tx)} style={{float:'right'}}>{this.state.selected_invoice.tx}</a></p>
                      <p className='payment-addresses'>{this.props.traductions.invoice.L_DATE}: <span style={{float:'right'}}>{this.state.selected_invoice.created_date}</span></p>
                      <div className='save-button-container'>
                        <Button className="save-button-invoice" onClick={() => { this.sendContactPDF(); }}>
                          {this.props.traductions.invoice.btn_download}
                        </Button>
                      </div>
                    </>
                  :
                  <>
                    <p className='payment-addresses'>{this.props.traductions.invoice.L_status}: <span className={this.state.selected_status} style={{float:'right'}}>{this.state.selected_status}</span></p>
                    <p className='payment-addresses'>{this.props.traductions.invoice.L_AMOUNT}: <span style={{float:'right'}}>{formatMoney(this.state.group_info['cost_' + this.state.group_info.payment_subscription])}</span></p>

                    <p className='invoice-bottom-text'>{this.props.traductions.invoice.note}: hello@wirebit.com</p>
                  </>
                  }
                </div>
              </Col>
            </Row>

        </div>
    );
  }


  receivedAmount(){
    if(this.state.amountW && this.state.planInfo) return ((this.state.amountW) * (1- (this.state.planInfo.transaction_fee/100))).toFixed(8)
  }


}

export default InvoicesIndex;
